import cookie from 'js-cookie';
import reqwest from 'reqwest';

export default function apiRequest(options) {
  const token = cookie.get('token');

  if (token) {
    options.headers = Object.assign({}, options.headers, {
      Authorization: `Bearer ${token}`,
    });
  }

  return reqwest(options);
}
